import React, { memo } from 'react'

import CampoVinculos from '../../components/CampoVinculos'
import {
  FieldError, FormGrid, FormLabel, FormRow, FormSection, SelectInput, TextArea, TextInput
} from '../../components/ui'
import { OPCOES_GENERO } from '../../constants/genero'
import UFS from '../../constants/ufs'

/* Cadastro do médico. A casca do modal vem do FormModal, igual em todas as telas.

   O que o admin preenche aqui é justamente o que o médico NÃO edita sozinho no
   portal: a credencial (CRM), os planos que ele atende e as clínicas em que
   atende. O paciente vê esses três antes de decidir liberar os exames.

   Sobre as duas inscrições: o CRM é emitido por Conselho Regional, então quem
   atende em dois estados tem um número em cada, e o paciente pode chegar com
   qualquer um dos dois. A secundária existe só aqui — quem confere a
   credencial é o admin. */

const Campo = ({ label, name, values, errors, touched, handleChange, handleBlur, ...rest }) => (
  <FormRow>
    <FormLabel>{label}</FormLabel>
    <TextInput
      autoComplete='nope'
      name={name}
      value={values[name] || ''}
      onChange={handleChange}
      onBlur={handleBlur}
      $error={!!errors[name]}
      {...rest}
    />
    <FieldError>{touched[name] && errors[name]}</FieldError>
  </FormRow>
)

const SelecionarUF = ({ label, name, values, errors, touched, handleChange, handleBlur }) => (
  <FormRow>
    <FormLabel>{label}</FormLabel>
    <SelectInput
      name={name}
      value={values[name] || ''}
      onChange={handleChange}
      onBlur={handleBlur}
      $error={!!errors[name]}
    >
      <option value=''>Selecione</option>
      {UFS.map(uf => <option key={uf} value={uf}>{uf}</option>)}
    </SelectInput>
    <FieldError>{touched[name] && errors[name]}</FieldError>
  </FormRow>
)

const Form = ({
  isCreating = false, values, errors, touched, handleChange, handleBlur, setFieldValue,
  especialidades = [], planos = [], clinicas = []
}) => {
  const props = { values, errors, touched, handleChange, handleBlur }

  return (
    <FormGrid>
      <FormSection>Identificação</FormSection>

      <Campo label='Nome' name='name' {...props} />
      <Campo label='E-mail' name='login' type='email' {...props} />
      {isCreating && <Campo label='Senha' name='password' type='password' {...props} />}
      <Campo label='Celular' name='phone' placeholder='(00) 00000-0000' {...props} />
      <Campo label='Data de nascimento' name='birth_date' type='date' {...props} />

      <FormRow>
        <FormLabel>Gênero</FormLabel>
        <SelectInput name='gender' value={values.gender || ''} onChange={handleChange} onBlur={handleBlur}>
          <option value=''>Selecione</option>
          {OPCOES_GENERO.map(o => <option key={o.valor} value={o.valor}>{o.rotulo}</option>)}
        </SelectInput>
        <FieldError />
      </FormRow>

      <FormSection>Registro no Conselho</FormSection>

      <Campo label='CRM' name='crm' inputMode='numeric' placeholder='Somente números' {...props} />
      <SelecionarUF label='UF do CRM' name='crm_uf' {...props} />
      <Campo label='CRM secundário' name='crm_secondary' inputMode='numeric' placeholder='Opcional' {...props} />
      <SelecionarUF label='UF do secundário' name='crm_secondary_uf' {...props} />

      <FormSection>Atendimento</FormSection>

      <FormRow>
        <FormLabel>Especialidade primária</FormLabel>
        <SelectInput name='specialty_primary' value={values.specialty_primary || ''}
          onChange={handleChange} onBlur={handleBlur}>
          <option value=''>Selecione</option>
          {especialidades.map(e => <option key={e.id} value={e.id}>{e.name}</option>)}
        </SelectInput>
        <FieldError />
      </FormRow>

      <FormRow>
        <FormLabel>Especialidade secundária</FormLabel>
        <SelectInput name='specialty_secondary' value={values.specialty_secondary || ''}
          onChange={handleChange} onBlur={handleBlur}>
          <option value=''>Selecione</option>
          {especialidades.map(e => <option key={e.id} value={e.id}>{e.name}</option>)}
        </SelectInput>
        <FieldError />
      </FormRow>

      <Campo label='Valor da consulta' name='price' placeholder='350,00' {...props} />

      <FormRow $full>
        <FormLabel>Descrição</FormLabel>
        <TextArea name='description' value={values.description || ''}
          onChange={handleChange} onBlur={handleBlur}
          placeholder='Como o médico se apresenta ao paciente' />
        <FieldError />
      </FormRow>

      <CampoVinculos
        label='Planos atendidos' name='health_insurances' opcoes={planos}
        values={values} setFieldValue={setFieldValue}
        vazio='Nenhum plano cadastrado. Cadastre em Planos.'
      />

      <CampoVinculos
        label='Clínicas' name='establishments' opcoes={clinicas}
        values={values} setFieldValue={setFieldValue}
        vazio='Nenhuma clínica cadastrada. Cadastre em Estabelecimentos.'
      />
    </FormGrid>
  )
}

export default memo(Form)
